import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from 'src/app/services/http/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from 'src/app/interfaces/app-state';
import { Spinkit } from 'ng-http-loader';
import { IPageData } from 'src/app/interfaces/page-data';
import { BasePageComponent } from '../../base-page';
import * as PageActions from '../../../store/actions/page.actions';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-myfriends',
  templateUrl: './myfriends.component.html',
  styleUrls: ['./myfriends.component.scss']
})
export class MyfriendsComponent extends BasePageComponent implements OnInit, OnDestroy {

  pageData: IPageData;
 
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  token
  tableids
  dishId
  allreviewData 
  errorMessage 
  allergenreview =[]
  listoffriends  =[];
  referalcode: any;
  Baselinkshare: string;
  noOfFriend : number
  closeDropdown: EventEmitter<boolean>;

  constructor(store: Store<IAppState>,
    public httpSv: HttpService,private router:Router,
    private route: ActivatedRoute
    ) { 
    super(store, httpSv);
    this.closeDropdown = new EventEmitter<boolean>();
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route:'sharefriends'
        }
      ]
    };   
  } 
  ngOnInit() {
    this.restoID=sessionStorage.getItem("restoId")
    this.token=sessionStorage.getItem('access_token')
    this.ids=sessionStorage.getItem('restoIds')
    this.tableids =sessionStorage.getItem('tableIds')
    this.dishId = sessionStorage.getItem('DishId')
    this.route.queryParams.subscribe(params => {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
});
this.httpSv.shareCodeGet().subscribe(res=>{
  if(res['status'] == true){
    this.referalcode = btoa(res['result'].data)
    this.Baselinkshare= environment.sharelinkUrldecode + this.referalcode 
  }
}, (err: HttpErrorResponse) => {
  this.errorMessage = err.error.message;
  if (err.status == 401) {
    this.logout();
  }
  else if (err.status == 500) {
    this.logout();
  }      
})
if (this.UserCondition) {
  this.friends();
  this.shareCodeGet();
}
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }
  logout() {
		this.httpSv.logouts(this.token).subscribe(
			response => {
				if (response['status'] == true) {
					sessionStorage.clear();
					this.router.navigate(['public/resto'], {
						queryParams: {
							id: this.ids,
							table_id: this.tableids
						}
					});
				} 
			}
		)
	}

  friends(){
    this.httpSv.friends().subscribe(res =>{
      if (res['status'] == true){
        this.listoffriends = res['result']
        this.noOfFriend = this.listoffriends.length
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
            
    })
  }
 
  shareCodeGet(){
    this.httpSv.shareCodeGet().subscribe(res=>{
      if(res['status'] == true){
        this.referalcode = btoa(res['result'].data)
      }
    },(err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
            
    })
  }
  onCloseDropdown() {
    this.closeDropdown.emit(true);
  }
  onclickFb(){
    let Baselink = environment.sharelinkUrlFb + this.referalcode 
    window.location.href = Baselink
  }
  onclickwhatapp(){
    let Baselink = environment.sharelinkUrlwhatapp + this.referalcode 
    window.location.href = Baselink

  }
  onclickTwitter(){
    let Baselink = environment.sharelinkUrltwitter + this.referalcode 
    window.location.href = Baselink

  }
  ondeletefriend(id){
    this.onCloseDropdown();
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        this.httpSv.deletefriends(id).subscribe(res =>{
          if(res['status'] == true ){
            this.ngOnInit();
            // this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            //   this.router.navigate(['horizontal/friends']);
            //  }); 
          }
        })
      }
    });
   
  }
  goBackToProfile(){
    this.router.navigate(['/horizontal/profile'])
  }
}
